/**
 * This component sits in the app bar.  It provides a notification icon for resellers
 * to activate their account.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import AbEnvironment from '../auth/AbEnvironment';

import HourglassEmpty from '@mui/icons-material/HourglassEmpty';
import { Tooltip } from '@mui/material';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    helpicon: {
      marginTop: 3,
      marginRight: 10,
      width: 30,
      height: 30,
      color: "#ffbf00",
    }
});

class AccountActivation extends Component {

    gotoSteps() {
      localStorage.removeItem('activateSteps');  //this makes steps pop in backdrop
      this.props.history.push(`/home`);
    }

    render() {
      const classes = this.props.classes;

      //temporary code
      let newActivationOn = false;
      if (localStorage.getItem("verification") === "1") {
        newActivationOn = true;
      }


      let personaStatus = abEnvironment.getUserAttribute("a_personaStatus")


      if (newActivationOn && personaStatus !== 'passed') {
        return (
          <Tooltip id="tooltip-h" title="Click here to activate your account" placement="bottom">
            <HourglassEmpty 
              className={classes.helpicon}
              onClick={() => {this.gotoSteps()}}
              >
            </HourglassEmpty>
          </Tooltip>
        );
      } else if (newActivationOn && personaStatus === 'passed') {
          return (
            
              <HourglassEmpty 
                className={classes.helpicon}
                onClick={() => {this.gotoSteps()}}
                >
              </HourglassEmpty>
          );
      } else {
        return (null);
      }
    }
}
  
AccountActivation.propTypes = {
  classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(AccountActivation);